import "./EligibilityCheckerRoot.scss";

import {
  LandingPage,
  PostcodeCheckerRoot,
  AgeCheckerRoot,
  PhysicalHealthRoot,
  SexCheckerRoot,
  MentalHealthRoot,
  DisabilitiesRoot,
  IntroduceYourself,
  ContactNumber,
  OnARoll,
  AlmostDone,
} from "../../EligibilityCheckerGeneric";
import { ModalPageBackground } from "../../../organisms/ModalPage";
import { MemoryRouter, Route, Switch } from "react-router";
import PageBg from "../../../../assets/img/bg/eligibilityCheckerBg.png";
import { LastSmokedRoot } from "../LastSmoked/LastSmokedRoot";
import { Pages } from "../../../../data/eligibilityChecker/smokeFree/pages";
import { smokeFreePageTitle } from "../../../../data/Programme";
import useUserId from "../../../hooks/useUserId";
import { useGetProfileByIdQuery } from "../../../../redux/profileApiV3";
import { getLatestProfileJourneyLocal } from "../../EligibilityCheckerGeneric/helpers";
import { useEffect, useState } from "react";
import { Journey } from "../../../../types/ProfileViewModel";
import { programmes } from "../../../../enums/programmes";

const EligibilityCheckerRoot = () => {
  const [latestJourney, setLatestJourney] = useState<Journey | null>(null);

  const [userId] = useUserId();
  const { data: profile } = useGetProfileByIdQuery(userId);

  useEffect(() => {
    if (!profile) {
      return;
    }

    const latestJourneyLocal = getLatestProfileJourneyLocal(profile);

    setLatestJourney(latestJourneyLocal);
  }, [profile]);

  return (
    <ModalPageBackground
      className="eligibility-checker-page eligibility-checker-page--smoke-free"
      bgImage={PageBg}
    >
      <MemoryRouter>
        <Switch>
          <Route exact path={"/"}>
            <LandingPage
              landingPageData={Pages.landingPage}
              programmeTitle={smokeFreePageTitle}
              nextStepUrl="/smoked-in-48h"
              progressPercentage={0}
            />
          </Route>
          <Route path={"/smoked-in-48h"}>
            <LastSmokedRoot progressPercentage={0} />
          </Route>
          <Route path={"/postcode"}>
            <PostcodeCheckerRoot
              existingPostcode={latestJourney?.postcode}
              postcodePageData={Pages.postcodeChecker}
              programmeTitle={smokeFreePageTitle}
              nextStepUrl="/age"
              programmeId={programmes["smoke-free"].id}
              progressPercentage={10}
            />
          </Route>
          <Route path={"/age"}>
            <AgeCheckerRoot
              existingDob={new Date(profile?.personalDetails?.dateOfBirth)}
              programmeTitle={smokeFreePageTitle}
              pageData={Pages.age}
              progressPercentage={20}
            />
          </Route>
          <Route path={"/sex"}>
            <SexCheckerRoot
              sex={profile?.personalDetails.birthSex}
              gender={profile?.personalDetails.gender}
              genderIsBirthSex={profile?.personalDetails.genderIsBirthSex}
              isPregnant={latestJourney?.isPregnant}
              isBreastFeeding={latestJourney?.isBreastFeeding}
              programmeTitle={smokeFreePageTitle}
              progressPercentage={30}
            />
          </Route>
          <Route path={"/physical-health"}>
            <PhysicalHealthRoot
              healthConditions={latestJourney?.healthConditions}
              programmeTitle={smokeFreePageTitle}
              physicalHealthPageData={Pages.physicalHealth}
              nextStepUrl="/mental-health"
              progressPercentage={40}
            />
          </Route>
          <Route path={"/mental-health"}>
            <MentalHealthRoot
              healthConditions={latestJourney?.healthConditions}
              programmeTitle={smokeFreePageTitle}
              mentalHealthPageData={Pages.mentalHealth}
              nextStepUrl="/disabilities"
              progressPercentage={50}
            />
          </Route>
          <Route path={"/disabilities"}>
            <DisabilitiesRoot
              disabilities={latestJourney?.healthConditions?.disabilities}
              programmeTitle={smokeFreePageTitle}
              disabilitiesPageData={Pages.disabilities}
              nextStepUrl="/on-a-roll"
              progressPercentage={60}
            />
          </Route>
          <Route path={"/on-a-roll"}>
            <OnARoll
              pageRedirectionLogicOrNextStepUrl="/introduce-yourself"
              onARollPageData={Pages.onARoll}
            />
          </Route>
          <Route path={"/introduce-yourself"}>
            <IntroduceYourself
              programmeTitle={smokeFreePageTitle}
              profileFirstName={profile?.personalDetails.firstName}
              profileLastName={profile?.personalDetails.lastName}
              progressPercentage={70}
            />
          </Route>
          <Route path={"/contact-number"}>
            <ContactNumber
              programmeTitle={smokeFreePageTitle}
              profilePhoneNumber={profile?.personalDetails.phoneNumber}
              progressPercentage={80}
            />
          </Route>
          <Route path={"/almost-done"}>
            <AlmostDone
              programmeTitle={smokeFreePageTitle}
              programmeSlug="smoke-free"
              profileBuilderUrl="/profile-builder"
              progressPercentage={90}
            />
          </Route>
        </Switch>
      </MemoryRouter>
    </ModalPageBackground>
  );
};

export default EligibilityCheckerRoot;
